import PropTypes from 'prop-types';
import { BsPlus, BsCloudUpload } from 'react-icons/bs';

import Button from '#globalComponents/Button/Button';
import Card from '#globalComponents/Card/Card';
import TableSearchInput from '#globalComponents/Table/filters/TableSearchInput';

const CompanyTableToolbar = ({ totalCompanies, search, onSearchChange, onCreateCompany, onImport }) => (
	<Card className="flex items-center justify-between px-3.5 py-2.5 mb-3.5">
		<div className="flex items-center gap-2.5">
			<h1 className="text-sm font-bold text-text tracking-tight">Unternehmen</h1>
			<span className="text-[11px] text-bgBase-800 font-medium">{totalCompanies} Unternehmen</span>
		</div>
		<div className="flex items-center gap-2">
			<TableSearchInput value={search} onChange={onSearchChange} placeholder="Firma suchen …" className="w-64" />

			{onImport && (
				<Button onClick={onImport} variant="outline" size="sm">
					<BsCloudUpload className="w-3.5 h-3.5" /> Importieren
				</Button>
			)}

			<Button onClick={onCreateCompany} variant="outline" size="sm">
				<BsPlus className="w-3.5 h-3.5" /> Unternehmen
			</Button>
		</div>
	</Card>
);

CompanyTableToolbar.propTypes = {
	totalCompanies: PropTypes.number.isRequired,
	search: PropTypes.string,
	/** Receives the trimmed term, or undefined when cleared. */
	onSearchChange: PropTypes.func.isRequired,
	onCreateCompany: PropTypes.func.isRequired,
	onImport: PropTypes.func,
};

export default CompanyTableToolbar;
